// copied this from an unfinished personal project, enjoy

import React, {
	useEffect, useContext, createContext, useState, useCallback,
} from 'react';
import propTypes from 'prop-types';
import firebase from 'firebase';
import 'firebase/analytics';
import 'firebase/firestore';
import equal from 'deep-equal';
import Cache from 'lru-cache';

const ONE_MINUTE_MS = 60000;
const CACHE_AGE = 5 * ONE_MINUTE_MS;

const mergeCache = new Cache({ maxAge: CACHE_AGE });

const firebaseConfig = {
	// Main: lwextralife
	apiKey: 'AIzaSyB3JQKorxJyfmk93YZyJLbriTvI4kArSmw',
	authDomain: 'lwextralife.firebaseapp.com',
	databaseURL: 'https://lwextralife.firebaseio.com',
	projectId: 'lwextralife',
	storageBucket: 'lwextralife.appspot.com',
	messagingSenderId: '802016660997',
	appId: '1:802016660997:web:c3b77dac259ae3b2df166c',
	measurementId: 'G-QGB2GTJ7JM',

	// Backup: lwextralife2
	// apiKey: 'AIzaSyCn5Kk9ktEi1VQ4hPc9dVfe8VgX7fXkB-U',
	// authDomain: 'lwextralife2.firebaseapp.com',
	// projectId: 'lwextralife2',
	// storageBucket: 'lwextralife2.appspot.com',
	// messagingSenderId: '21522479439',
	// appId: '1:21522479439:web:1cbad5458709c4b1d62d3a',
};

export const firebaseContext = createContext();

export default function useFirebase() {
	return useContext(firebaseContext);
}

export async function refMerge(ref, data) {
	let current = mergeCache.get(ref.path);
	if (!current) {
		const doc = await ref.get();
		current = doc.data();
	}

	const mergeData = { ...current, ...data };
	mergeCache.set(ref.path, mergeData);

	if (equal(current, mergeData)) return;
	await ref.set(data, { merge: true });
}

export function useFirestoreDocRT(path) {
	const { firestore } = useFirebase();

	const [value, setValue] = useState();

	useEffect(() => {
		if (!path) {
			setValue();
			return () => {};
		}

		const ref = firestore.doc(path);
		const unsubscribe = ref.onSnapshot((doc) => {
			setValue(doc.data());
		}, () => {
			setValue();
		});

		return () => {
			unsubscribe();
		};
	}, [firestore, path]);

	return value;
}

export function useFirestoreCollectionRT(path, opts = undefined) {
	const { firestore } = useFirebase();

	const [value, setValue] = useState();

	useEffect(() => {
		let ref = firestore.collection(path);
		const { orderBy, limit } = opts || {};
		if (orderBy) {
			ref = ref.orderBy(...orderBy);
		}
		if (limit) {
			ref = ref.limit(limit);
		}

		const unsubscribe = ref.onSnapshot((snp) => {
			const list = {};
			snp.forEach((doc) => {
				list[doc.id] = doc.data();
			});
			setValue(list);
		}, () => {
			setValue();
		});

		return () => {
			unsubscribe();
		};
	}, [firestore, path, opts]);

	return value;
}

export function FirebaseProvider(props) {
	const { children } = props;

	const [analytics, setAnalytics] = useState();
	const [auth, setAuth] = useState();
	const [firestore, setFirestore] = useState();
	const [currentUser, setCurrentUser] = useState();

	useEffect(() => {
		firebase.initializeApp(firebaseConfig);
		setAnalytics(firebase.analytics());
		setAuth(firebase.auth());
		setFirestore(firebase.firestore());
	}, []);

	useEffect(() => {
		if (!analytics) return;
		analytics.logEvent('init');
	}, [analytics]);

	const signInGoogle = useCallback(async () => {
		const provider = new firebase.auth.GoogleAuthProvider();
		await auth.signInWithPopup(provider);
		return auth.currentUser;
	}, [auth]);

	const signOut = useCallback(async () => {
		await auth.signOut();
	}, [auth]);

	useEffect(() => {
		if (!auth) return () => {};
		const unsubscribe = auth.onAuthStateChanged((user) => {
			setCurrentUser(user);
		});

		return () => {
			unsubscribe();
		};
	}, [auth]);

	if (!analytics || !auth || !firestore) {
		return false;
	}

	const value = {
		analytics,
		auth,
		firestore,
		signInGoogle,
		signOut,
		currentUser,
	};

	return (
		<firebaseContext.Provider value={value}>
			{children}
		</firebaseContext.Provider>
	);
}

FirebaseProvider.propTypes = {
	children: propTypes.node.isRequired,
};
